import userInterfaceSvg from "@/utils/svg-icon/userInterface";
import React, { FC, useMemo, useState } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import GooglePlacesAutocomplete from "react-google-places-autocomplete";

type CitiesGoogleProp = {
    placeholder?: string;
    className?: string;
    validation?: () => boolean;
    setValue: (city: string) => void;
};

const CitiesGoogle: FC<CitiesGoogleProp> = ({
    className = "",
    validation,
    setValue,
    placeholder = "Write city...",
}) => {
    const [focused, setFocused] = useState<boolean>(false);
    const [touched, setTouched] = useState<boolean>(false);
    const [address, setAddress] = useState<string>("");

    const { ArrowDownSimpleLine } = userInterfaceSvg;

    const borderClassName = useMemo(() => {
        if (touched && validation) {
            if (validation()) {
                return "borderGreen";
            }
            return "borderRed";
        }

        if (!focused) {
            return "borderGrey";
        }

        if (address?.length === undefined || address === "") {
            return focused ? "borderGrey" : "borderRed";
        }

        return "#55ce97";
    }, [address, focused, validation, touched]);

    const handleChange = (
        args: {
            value: {
                terms: { offset: number; value: string }[];
                structured_formatting: { main_text: string };
            };
        } | null
    ) => {
        if (!args) {
            setAddress("");
            setValue("");
            return;
        }

        setAddress("");
        setValue(args.value.structured_formatting.main_text);
    };

    const customDropdownIndicator = () => {
        return (
            <div className="customDropdownIndicator">
                {validation && validation() ? (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="#55ce97"
                    >
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                    </svg>
                ) : (
                    <ArrowDownSimpleLine />
                )}
            </div>
        );
    };

    return (
        <div
            className={`${className} ${borderClassName}`}
            onFocus={() => setFocused(true)}
            onBlur={() => {
                setFocused(false);
                setTouched(true);
            }}
        >
            <GooglePlacesAutocomplete
                autocompletionRequest={{
                    componentRestrictions: {
                        country: "it",
                    },
                }}
                selectProps={{
                    isClearable: true,
                    value: address ? { value: address, label: address } : null,
                    onChange: handleChange,
                    placeholder: (
                        <div style={{ color: "#777e90" }}>{placeholder}</div>
                    ),
                    noOptionsMessage: () => null,
                    loadingMessage: () => "Loading...",
                    styles: {
                        input: () => ({
                            color: "#777e91",
                            fontFamily: "GeneralSans-Regular",
                        }),
                        singleValue: () => ({
                            color: "#777e91",
                            fontFamily: "GeneralSans-Regular",
                        }),
                    },
                    components: {
                        DropdownIndicator: customDropdownIndicator,
                    },
                }}
                apiOptions={{
                    libraries: ["places", "geometry"],
                    apiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY,
                }}
                apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY}
            />
        </div>
    );
};

export default CitiesGoogle;
